import React from 'react';
import { LoadingIcon } from './LoadingIcon';

interface FullScreenLoaderProps {
  id: string;
  textColor: string;
  margin_y?: string;
}

export const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({
  id,
  textColor,
  margin_y,
}: FullScreenLoaderProps) => (
  <label htmlFor={id} className={`${margin_y || 'my-9'} animate-spin w-10`}>
    <LoadingIcon className={`${textColor}`} dimensions="w-10 h-10" />
  </label>
);

FullScreenLoader.defaultProps = {
  margin_y: 'my-9',
};
